import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Menu, Card, Statistic, Row, Col, Button, message } from 'antd';
import { 
  DashboardOutlined, 
  KeyOutlined, 
  FileTextOutlined, 
  LogoutOutlined,
  UserOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';
import { adminAPI } from '../../utils/api';
import './AdminDashboard.css';

const { Header, Sider, Content } = Layout;

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await adminAPI.getStats();
      if (response && response.success) {
        setStats(response.stats);
      }
    } catch (error) {
      message.error('加载统计数据失败');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    message.success('已退出登录');
    navigate('/XiaoXin/login');
  };

  const menuItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: '仪表板',
      onClick: () => navigate('/XiaoXin/dashboard')
    },
    {
      key: 'authcodes',
      icon: <KeyOutlined />,
      label: '授权码管理',
      onClick: () => navigate('/XiaoXin/authcodes')
    },
    {
      key: 'results',
      icon: <FileTextOutlined />,
      label: '使用记录',
      onClick: () => navigate('/XiaoXin/results')
    }
  ];

  return (
    <Layout className="admin-layout">
      <Sider className="admin-sider" width={240}>
        <div className="admin-sider-header">
          <div className="admin-logo">💕 RPI</div>
          <div className="admin-subtitle">管理后台</div>
        </div>
        <Menu
          mode="inline"
          selectedKeys={['dashboard']}
          items={menuItems}
          className="admin-menu"
        />
        <div className="admin-sider-footer">
          <Button 
            type="text" 
            icon={<LogoutOutlined />} 
            onClick={handleLogout}
            block
          >
            退出登录
          </Button>
        </div>
      </Sider>

      <Layout>
        <Header className="admin-header">
          <h1>仪表板</h1>
        </Header>

        <Content className="admin-content">
          <Row gutter={[24, 24]}>
            <Col xs={24} sm={12} lg={6}>
              <Card loading={loading}>
                <Statistic
                  title="总授权码"
                  value={stats?.totalCodes || 0}
                  prefix={<KeyOutlined />}
                  valueStyle={{ color: '#3f8600' }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card loading={loading}>
                <Statistic
                  title="已使用"
                  value={stats?.usedCodes || 0}
                  prefix={<CheckCircleOutlined />}
                  valueStyle={{ color: '#1890ff' }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card loading={loading}>
                <Statistic
                  title="未使用"
                  value={stats?.unusedCodes || 0}
                  prefix={<ClockCircleOutlined />}
                  valueStyle={{ color: '#faad14' }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <Card loading={loading}>
                <Statistic
                  title="完成测试"
                  value={stats?.completedTests || 0}
                  prefix={<UserOutlined />}
                  valueStyle={{ color: '#cf1322' }}
                />
              </Card>
            </Col>
          </Row>

          <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
            <Col xs={24}>
              <Card title="快速操作">
                <div className="admin-quick-actions">
                  <Button 
                    type="primary" 
                    size="large"
                    icon={<KeyOutlined />}
                    onClick={() => navigate('/XiaoXin/authcodes')}
                  >
                    生成授权码
                  </Button>
                  <Button 
                    size="large"
                    icon={<FileTextOutlined />}
                    onClick={() => navigate('/XiaoXin/results')}
                  >
                    查看使用记录
                  </Button>
                </div>
              </Card>
            </Col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminDashboard;
